// React libraries
import React from 'react';
import classnames from 'classnames';
// Component Style
import { useStyles } from "./StepperStyles";
// Material UI Core
import Typography from '@mui/material/Typography';
import MUIStepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
// Icons
import { Checkmark } from "../../icons";
export const Stepper = props => {
    const classes = useStyles(props);
    const { id, textOrientation, steps, activeStep, handleNextCallback, handleBackCallback, style } = props;
    const stepClasses = {
        horizontal: classes.horizontal,
        vertical: classes.vertical
    };
    const labelClasses = {
        iconContainer: classes.iconContainer,
        completed: classes.labelCompleted,
        active: classes.labelActive,
        label: classes.label
    };
    const StepperStepIcon = props => {
        const { active, completed } = props;
        const stepIconClasses = classnames({
            [classes.root]: true,
            [classes.active]: active,
            [classes.completed]: completed
        });
        return (React.createElement("div", { className: classes.root }, completed ?
            React.createElement(Checkmark, { style: { width: "24px", height: "24px" }, className: classes.completed }) :
            React.createElement("div", { className: stepIconClasses },
                React.createElement(Typography, { className: classes.iconText, gutterBottom: true }, props.icon))));
    };
    return (React.createElement("div", { className: classes.rootContainer, style: style, id: id },
        React.createElement("div", { className: classes.stepperContainer },
            React.createElement(MUIStepper, { orientation: textOrientation, activeStep: activeStep, className: classes.stepper }, steps.map((step, index) => (React.createElement(Step, { key: `step${index}`, classes: stepClasses },
                React.createElement(StepLabel, { StepIconComponent: StepperStepIcon, classes: labelClasses }, step.label),
                React.createElement(StepContent, null,
                    React.createElement(Typography, null, step.content)))))))));
};
Stepper.defaultProps = {
    steps: [],
    initialStep: 0,
    textOrientation: 'horizontal',
    handleNextCallback: () => { },
    handleBackCallback: () => { },
    handleCancel: () => { }
};
export default Stepper;
